import { DeleteOutlined, DownOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Col,
  ConfigProvider,
  Form,
  FormInstance,
  Row,
  Segmented,
  Collapse,
  Divider,
  message,
  Radio,
  Switch,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../../components/Button/Button";
import { AchievementCardContainer } from "../../../components/Card/CardContainer";
import Text from "../../../components/Text/Text";
import { color, image } from "../../../resource";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import ImgCrop from "../../../components/ImgCrop/ImgCrop";
import { CustomFormItemRewaed, UploadBoxBadge, UploadBoxReward } from "../StyleCSS";
import { ImageWithDeleteButton, UploadIcon } from "../../../components/Image/Image";
import { getBadgeMaster } from "../../../datasource/BadgeMasterDatasource";
import {
  createMainStep2,
  createSpecialStep2,
  deleteAchievementReward,
  getDataStep2,
} from "../../../datasource/AchievementDataSource";
import { useEffectOnce } from "react-use";
import { useWatch } from "antd/lib/form/Form";
import { mapStatusEdit } from "../../../definitions/achievementStatus";
import { imgList } from "../CreateAchievement";

const AddAchievementContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;

  width: 100%;
  padding: 16px 50px;

  cursor: pointer;

  background: ${color["background1"]};
  border: 1px dashed ${color["primary"]};
  border-radius: 12px;
`;
export const CollapseContainer = styled(Collapse)`
  .ant-collapse-expand-icon {
    align-self: center;
  }
`;
const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
  fillColor: "transparent",
};
interface Props {
  key: number;
  form2: FormInstance;
  achievementRewardId: string;
  setDisableStep: any;
  targetType: string;
  status: string;
  isApproved: boolean;
  mainImgBadge: imgList[];
  setMainImgBadge: any;
  mainImgReward: imgList[];
  setMainImgReward: any;
  specialImgBadge: imgList[];
  setSpecialImgBadge: any;
  specialImgReward: imgList[];
  setSpecialImgReward: any;
  isSpecialReward: boolean;
  setIsSpecialReward: any;
}
function AchievementStep2({
  key,
  form2,
  achievementRewardId,
  setDisableStep,
  targetType,
  status,
  isApproved,
  mainImgBadge,
  setMainImgBadge,
  mainImgReward,
  setMainImgReward,
  specialImgBadge,
  setSpecialImgBadge,
  specialImgReward,
  setSpecialImgReward,
  isSpecialReward,
  setIsSpecialReward,
}: Props) {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [tab, setTab] = useState("main");
  const [mainGroup, setMainGroup] = useState<any>([]);
  const [specialGroup, setSpecialGroup] = useState<any>([]);
  const [badgeList, setBadgeList] = useState<any>();

  useWatch(["mainGroups"], form2);
  useWatch(["specialGroups"], form2);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isSwitch, setIsSwitch] = useState<boolean>(false);
  const [conditionMainList, setConditionMainList] = useState<any>([]);

  const getData = async (id: string) => {
    setIsEdit(mapStatusEdit(status, isApproved));
    await getDataStep2(id).then((res) => {
      form2.setFieldsValue({
        achievementRewardId: res.achievementRewardId,
        isSpecial: res.isSpecial,
        receiveSpecialRewardType: res.receiveSpecialRewardType || "STEP",
        mainGroups: res.achievementMainReward
          ?.sort((a, b) => a.rewardNum - b.rewardNum)
          .map((e) => ({
            mainRewardId: e.mainRewardId,
            mileStoneName: e.mileStoneName,
            rewardName: e.rewardName,
            rewardNum: e.rewardNum,
            targetAmount: e.targetAmount,
            targetUnit: e.targetUnit,
            badgeMasterId: e.badgeMasterId,
            key: e.rewardNum,
            reward: e.imageUrl,
            badge: e.badgeImageUrl,
          })),
        specialGroups: res.achievementSpecialReward
          ?.sort((a, b) => a.specialRewardNum - b.specialRewardNum)
          .map((e) => ({
            mainRewardId: e.specialRewardId,
            mileStoneName: e.mileStoneSpecialName,
            rewardName: e.specialRewardName,
            rewardNum: e.specialRewardNum,
            targetAmount: e.targetAmount,
            targetUnit: e.targetUnit,
            badgeMasterId: e.badgeMasterId,
            key: e.specialRewardNum,
            reward: e.imageUrl,
            unlockMainRewardNum: Number(e.unlockMainRewardNum),
            badge: e.badgeImageUrl,
          })),
      });
      setIsSpecialReward(res.isSpecial);
      if (res.achievementMainReward?.length > 0) {
        setMainGroup(
          res.achievementMainReward?.map((item) => ({
            key: item.rewardNum,
            label: addGroupLabel("mainGroups", item.rewardNum),
          })),
        );
      }
      if (res.achievementSpecialReward?.length > 0) {
        setSpecialGroup(
          res.achievementSpecialReward?.map((item) => ({
            key: item.specialRewardNum,
            label: addGroupLabel("specialGroups", item.specialRewardNum),
          })),
        );
      }
    });
  };

  useEffectOnce(() => {
    getBadgeMaster({ company: userProfile.company, page: 0, take: 0 }).then((res) => {
      setBadgeList(res.data);
    });
    if (achievementRewardId) {
      getData(achievementRewardId);
    }
  });

  useEffect(() => {
    setIsSwitch(form2.getFieldsValue(true).mainGroups?.length > 0 ? false : true);
    checkValidate();
    setConditionMainList(
      form2?.getFieldsValue(true).mainGroups?.map((item) => ({
        key: item.rewardNum,
        value: item.rewardNum,
        label: item.mileStoneName,
      })),
    );
  }, [tab, form2]);

  const checkValidate = async () => {
    try {
      await form2.validateFields().then(async (value) => {
        const checkDataBtTab =
          tab === "main"
            ? await form2.getFieldValue("specialGroups")
            : await form2.getFieldValue("mainGroups");
        const checkDataInTab =
          tab === "main"
            ? await form2.getFieldValue("mainGroups")
            : await form2.getFieldValue("specialGroups");

        const objectsWithUndefined = checkDataBtTab?.filter((item) =>
          Object.values(item).some((value) => value === undefined),
        );

        let checkDisable = true;
        if (tab == "main") {
          checkDisable =
            (objectsWithUndefined?.length || 0) > 0 || checkDataInTab?.length == 0 ? true : false;
        } else {
          checkDisable = (objectsWithUndefined?.length || 0) > 0 ? true : false;
        }
        setDisableStep(checkDisable);
      });
    } catch (e: any) {
      if (e.errorFields?.length > 0) {
        setDisableStep(true);
        const allErrors = e.errorFields;
      }
    }
  };

  const deleteBadge = async (category: string, key: number) => {
    const dataFrom = form2.getFieldsValue(true)[category][key - 1];
    const formDataImg = new FormData();
    if (category.includes("main")) {
      formDataImg.append("mainRewardId", dataFrom.mainRewardId);
      formDataImg.append("badgeAction", "DELETE");
      await createMainStep2(formDataImg).then((res) => res);
    } else {
      formDataImg.append("specialRewardId", dataFrom.mainRewardId);
      formDataImg.append("badgeAction", "DELETE");
      await createSpecialStep2(formDataImg).then((res) => res);
    }
  };

  const mapRelatedCondition = (key: number) => {
    const dataSpecial = form2.getFieldsValue(true).specialGroups;
    const before = dataSpecial?.find((x) => x.key === key - 1);
    const current = dataSpecial?.find((x) => x.key === key);
    const mapData = conditionMainList?.filter((x) => {
      return before?.unlockMainRewardNum <= x.key || current?.unlockMainRewardNum <= x.key;
    });
    return key === 1 ? conditionMainList : mapData;
  };

  const addGroupLabel = (category: string, key: number) => {
    return (
      <Row justify={"space-between"}>
        <Form.Item noStyle name={[category, key - 1, `mainRewardId`]}>
          <Col span={23} style={{ padding: "5px" }}>
            <Text level={5} fontWeight={600}>
              {tab == "main" ? `ระดับ ${key}` : `รางวัลพิเศษ ${key}`}
            </Text>
          </Col>
        </Form.Item>
        <Col span={1}>
          <Button
            disabled={isEdit}
            icon={<DeleteOutlined style={{ color: color.error }} />}
            typeButton='border-light'
            style={{ padding: "5px", width: 30, height: 30 }}
            onClick={() => {
              if (!isEdit && category.includes("main")) {
                const findRelate = form2
                  .getFieldsValue(true)
                  .specialGroups.filter((x) => x.unlockMainRewardNum == key);
                if (findRelate?.length > 0) {
                  Modal.confirm({
                    width: 480,
                    centered: true,
                    icon: null,
                    title: (
                      <Text level={4} fontWeight={600}>
                        ต้องการลบระดับการสะสมนี้หรือไม่?
                      </Text>
                    ),
                    content: (
                      <Text level={6} color='Text3'>
                        ระดับนี้มีการเชื่อมโยงกับรางวัลพิเศษ หากลบแล้ว
                        คุณจะต้องกลับไปอัปเดตรายการรางวัลพิเศษให้ถูกต้อง
                      </Text>
                    ),
                    okText: "ยืนยัน",
                    cancelText: "ยกเลิก",
                    onOk: async (e) => {
                      const dataSpecial = form2.getFieldsValue(true).specialGroups;
                      const mapData = dataSpecial?.map((x) => {
                        return { ...x, unlockMainRewardNum: undefined };
                      });
                      form2.setFieldValue(["specialGroups"], mapData);
                      setTab("special");
                      await deleteMainGroup(key);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    },
                  });
                } else {
                  deleteMainGroup(key);
                }
              } else {
                deleteSpecialGroup(key);
              }
            }}
          />
        </Col>
      </Row>
    );
  };

  const addGroup = (category: string, key: number, mainImgBadge: any, mainImgReward: any) => {
    const checkBadge = badgeList?.find(
      (x) => x.badgeMasterId == form2?.getFieldValue([category, key - 1])?.badgeMasterId,
    );
    checkValidate();
    return (
      <Form.Item key={key}>
        <Row justify={"space-between"}>
          <Col span={11}>
            <Form.Item
              name={[category, key - 1, `mileStoneName`]}
              label='ชื่อระดับการสะสม'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุชื่อการสะสม",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder='ระบุชื่อการสะสม'
                autoComplete='off'
                onChange={() => checkValidate()}
              />
            </Form.Item>
            <Form.Item
              name={[category, key - 1, `badgeMasterId`]}
              label='ตราสัญลักษณ์'
              rules={[
                {
                  required: true,
                  message: "*โปรดเลือกตราสัญลักษณ์",
                },
              ]}
            >
              <Select
                disabled={isEdit}
                placeholder='เลือกสัญลักษณ์'
                data={badgeList?.map((x) => ({
                  label: (
                    <Row justify={"start"} gutter={8}>
                      <Col span={4}>
                        <img src={x.badgeImageUrl} width='40px' />
                      </Col>
                      <Col span={20} style={{ paddingTop: "5px" }}>
                        <Text level={6} fontWeight={400}>
                          {x.badgeMasterName}
                        </Text>
                      </Col>
                    </Row>
                  ),
                  value: x.badgeMasterId,
                  key: x.badgeMasterId,
                }))}
                onChange={() => checkValidate()}
              />
            </Form.Item>
            {checkBadge?.badgeMasterName?.includes("ใหม่") && (
              <>
                <Divider>
                  <Text color='Text3'>หรือ</Text>
                </Divider>
                <FlexRow>
                  <FlexCol style={{ marginRight: 30 }}>
                    <CustomFormItemRewaed
                      name={[category, key - 1, `badge`]}
                      rules={[
                        {
                          required: true,
                          message: "*กรุณาเพิ่มรูปสัญลักษณ์",
                        },
                      ]}
                    >
                      <ImgCrop aspect={1} {...imgCropProps} key={key}>
                        <UploadBoxBadge
                          style={{
                            width: "100px",
                            height: "100px",
                          }}
                          listType='picture-card'
                          maxCount={1}
                          beforeUpload={async (file) => {
                            const isJpgOrPng = file.type === "image/png";
                            if (!isJpgOrPng) {
                              message.error("You can only upload PNG file!");
                              return true;
                            }
                            const readFileAsDataURL = (
                              file: File,
                            ): Promise<string | ArrayBuffer | null> => {
                              return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = reject;
                                reader.readAsDataURL(file);
                              });
                            };
                            const imgUrl = await readFileAsDataURL(file);
                            const mapData: any = (
                              category.includes("main") ? mainImgBadge : specialImgBadge
                            )?.map((x) => {
                              if (x.key === key) {
                                form2.setFieldValue([category, key - 1, "badge"], imgUrl);
                                return { key: key, imgFile: file, imgUrl };
                              } else {
                                return x;
                              }
                            });
                            category.includes("main") && (await setMainImgBadge(mapData));
                            category.includes("special") && (await setSpecialImgBadge(mapData));
                            checkValidate();
                            return true;
                          }}
                          onRemove={() => {
                            const mapData = (
                              category.includes("main") ? mainImgBadge : specialImgBadge
                            )?.map((x) => {
                              if (x.key === key) {
                                return { key: key, imgFile: undefined, undefined };
                              } else {
                                return x;
                              }
                            });
                            category.includes("main")
                              ? setMainImgBadge(mapData)
                              : setSpecialImgBadge(mapData);
                          }}
                          showUploadList={false}
                        >
                          {(category.includes("main") ? mainImgBadge : specialImgBadge)?.find(
                            (x) => x.key === key,
                          )?.imgUrl ? (
                            <ImageWithDeleteButton
                              width='100px'
                              height='100px'
                              src={
                                (category.includes("main") ? mainImgBadge : specialImgBadge)[
                                  key - 1
                                ]?.imgUrl
                              }
                              handleDelete={() => {
                                if (category.includes("main")) {
                                  setMainImgBadge((prev) =>
                                    prev?.map((x) =>
                                      x.key === key
                                        ? { ...x, imgFile: undefined, imgUrl: undefined }
                                        : x,
                                    ),
                                  );
                                } else {
                                  setSpecialImgBadge((prev) =>
                                    prev?.map((x) =>
                                      x.key === key
                                        ? { ...x, imgFile: undefined, imgUrl: undefined }
                                        : x,
                                    ),
                                  );
                                }
                                deleteBadge(category, key);
                              }}
                            />
                          ) : (
                            <div>{UploadIcon}</div>
                          )}
                        </UploadBoxBadge>
                      </ImgCrop>
                    </CustomFormItemRewaed>
                  </FlexCol>
                  <FlexCol>
                    <Text level={6}>
                      รูปแบบไฟล์ภาพ &nbsp;<span style={{ color: color.error }}>*</span>
                    </Text>
                    <Text level={6} color='Text3'>
                      PNG
                      <br />
                      ขนาดภาพ
                      <br />
                      150 x 150 px
                    </Text>
                  </FlexCol>
                </FlexRow>
              </>
            )}
          </Col>
          <Col span={1} style={{ display: "flex", justifyContent: "center" }}>
            <Divider type='vertical' style={{ height: "100%" }} />
          </Col>
          <Col span={11}>
            {category.includes("specialGroup") && (
              <Form.Item
                name={[category, key - 1, `unlockMainRewardNum`]}
                label='เงื่อนไขผ่านระดับสะสม'
                rules={[
                  {
                    required: true,
                    message: "*โปรดเลือกเงื่อนไขผ่านระดับสะสม",
                  },
                  ({ getFieldValue }) => ({
                    validator: async (_, value) => {
                      if (!value) return Promise.resolve();
                      const current = getFieldValue([category, key - 1]);
                      const dataForm = form2.getFieldsValue(true).specialGroups;
                      const isInvalid =
                        current?.unlockMainRewardNum > dataForm[key]?.unlockMainRewardNum;
                      if (isInvalid) {
                        const mapData = dataForm?.map((x) => {
                          const findData = x.rewardNum > current.rewardNum;
                          if (findData) {
                            return { ...x, unlockMainRewardNum: undefined };
                          } else {
                            return { ...x };
                          }
                        });
                        form2.setFieldValue(["specialGroups"], mapData);
                        checkValidate();
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Select
                  disabled={isEdit}
                  placeholder='เลือกระดับสะสมที่ต้องผ่าน'
                  data={mapRelatedCondition(key)}
                />
              </Form.Item>
            )}
            <Form.Item
              name={[category, key - 1, `targetAmount`]}
              label='เป้าหมาย'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุเป้าหมาย",
                },
                {
                  pattern: /^\d+(\.\d+)?$/,
                  message: "*ข้อความเป็นตัวเลขเท่านั้น",
                },
                {
                  validator: async (_, value) => {
                    if (category.includes("main")) {
                      if (!value) return Promise.resolve();
                      const dataMain = form2
                        .getFieldsValue(true)
                        .mainGroups.filter((x) => x.key < key);
                      const isInvalidMain = dataMain.some(
                        (d) => Number(value) <= Number(d.targetAmount),
                      );
                      if (isInvalidMain) {
                        return Promise.reject(new Error("*เป้าหมายต้องมากกว่าระดับก่อน"));
                      }
                      if (form2.getFieldsValue(true).specialGroups?.length > 0) {
                        const dataSpecial = form2
                          .getFieldsValue(true)
                          .specialGroups.some((d) => Number(value) <= Number(d.targetAmount));
                        if (!dataSpecial) {
                          return Promise.reject(new Error("*กรุณาแก้ไขเป้าหมายรางวัลพิเศษ"));
                        }
                      }
                    } else {
                      if (!value) return Promise.resolve();
                      const dataMain = form2.getFieldsValue(true).mainGroups;
                      const filterValue = dataMain.filter(
                        (x) => Number(x.targetAmount) > Number(value),
                      );
                      if (filterValue?.length > 0) {
                        const isInvalid = filterValue.some(
                          (d) => Number(value) <= Number(d.targetAmount),
                        );
                        if (isInvalid) {
                          return key == 1
                            ? Promise.reject(new Error("*เป้าหมายต้องมากกว่าระดับสะสมสุดท้าย"))
                            : Promise.reject(new Error("*เป้าหมายต้องมากกว่าระดับก่อน"));
                        }
                      } else {
                        const dataSpecial = form2.getFieldsValue(true).specialGroups;
                        const before = dataSpecial[key - 1];
                        const isInvalid = dataSpecial.some(
                          (d) => Number(d.targetAmount) < Number(value),
                        );
                        if (!isInvalid) {
                          return (
                            key > 1 && Promise.reject(new Error("*เป้าหมายต้องมากกว่าระดับก่อน"))
                          );
                        }
                      }
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder='ระบุเป้าหมาย'
                autoComplete='off'
                suffix={targetType === "THB" ? "บาท" : "จำนวน"}
                onChange={() => checkValidate()}
              />
            </Form.Item>
            <Form.Item
              name={[category, key - 1, `rewardName`]}
              label='รางวัล'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุรางวัล",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder='ระบุรางวัล'
                autoComplete='off'
                onChange={() => checkValidate()}
              />
            </Form.Item>
            <FlexRow>
              <FlexCol style={{ marginRight: 30 }} key={key}>
                <CustomFormItemRewaed
                  name={[category, key - 1, `reward`]}
                  rules={[
                    {
                      required: true,
                      message: "*กรุณาเพิ่มรูปของรางวัล",
                    },
                  ]}
                >
                  <ImgCrop aspect={3 / 4} {...imgCropProps}>
                    <UploadBoxReward
                      style={{
                        width: "140px",
                        height: "200px",
                      }}
                      listType='picture-card'
                      maxCount={1}
                      beforeUpload={async (file) => {
                        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
                        if (!isJpgOrPng) {
                          message.error("You can only upload JPG/PNG file!");
                          return true;
                        }
                        const readFileAsDataURL = (
                          file: File,
                        ): Promise<string | ArrayBuffer | null> => {
                          return new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result);
                            reader.onerror = reject;
                            reader.readAsDataURL(file);
                          });
                        };
                        const imgUrl = await readFileAsDataURL(file);
                        const mapData: any = (
                          category.includes("main") ? mainImgReward : specialImgReward
                        )?.map((x) => {
                          if (x.key === key) {
                            form2.setFieldValue([category, key - 1, "reward"], imgUrl);
                            return { key: key, imgFile: file, imgUrl };
                          } else {
                            return x;
                          }
                        });
                        category.includes("main") && (await setMainImgReward(mapData));
                        category.includes("special") && (await setSpecialImgReward(mapData));
                        checkValidate();
                        return true;
                      }}
                      onRemove={() => {
                        const mapData = (
                          category.includes("main") ? mainImgReward : specialImgReward
                        )?.map((x) => {
                          if (x.key === key) {
                            return { key: key + 1, imgFile: undefined, undefined };
                          } else {
                            return x;
                          }
                        });
                        category.includes("main")
                          ? setMainImgReward(mapData)
                          : setSpecialImgReward(mapData);
                      }}
                      showUploadList={false}
                      disabled={isEdit}
                    >
                      {(category.includes("main") ? mainImgReward : specialImgReward)?.find(
                        (x) => x.key === key,
                      )?.imgUrl ? (
                        <ImageWithDeleteButton
                          hideDelete={isEdit}
                          width='140px'
                          height='200px'
                          src={
                            (category.includes("main") ? mainImgReward : specialImgReward)[key - 1]
                              ?.imgUrl
                          }
                          handleDelete={() => {
                            form2.setFieldValue([category, key - 1, "reward"], undefined);
                            if (category.includes("main")) {
                              setMainImgReward((prev) =>
                                prev?.map((x) =>
                                  x.key === key
                                    ? { ...x, imgFile: undefined, imgUrl: undefined }
                                    : x,
                                ),
                              );
                            } else {
                              setSpecialImgReward((prev) =>
                                prev?.map((x) =>
                                  x.key === key
                                    ? { ...x, imgFile: undefined, imgUrl: undefined }
                                    : x,
                                ),
                              );
                            }
                            checkValidate();
                          }}
                        />
                      ) : (
                        <div>{UploadIcon}</div>
                      )}
                    </UploadBoxReward>
                  </ImgCrop>
                </CustomFormItemRewaed>
              </FlexCol>
              <FlexCol>
                <Text level={6}>
                  รูปภาพรางวัล &nbsp;<span style={{ color: color.error }}>*</span>
                </Text>
                <Text level={6} color='Text3'>
                  รูปแบบไฟล์ภาพ
                  <br />
                  JPG/PNG
                  <br />
                  ขนาดภาพ
                  <br />
                  700 x 800 px
                </Text>
              </FlexCol>
            </FlexRow>
          </Col>
        </Row>
      </Form.Item>
    );
  };

  const deleteMainGroup = async (key: number) => {
    const mapForm = form2.getFieldsValue(true).mainGroups;
    const mapKey = mapForm.find((d) => d.key === key).mainRewardId;

    const filterForm = mapForm
      .filter((f) => f.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1, rewardNum: i + 1 };
      });

    setConditionMainList(
      filterForm.map((item) => ({
        key: item.rewardNum,
        value: item.rewardNum,
        label: item.mileStoneName,
      })),
    );

    form2.resetFields(["mainGroups"]);
    form2.setFieldValue(["mainGroups"], filterForm);

    const mapDataMain = mainGroup
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });

    const mapMainBadge = mainImgBadge
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });

    const mapMainReward = mainImgReward
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });

    if (mapKey) {
      await deleteAchievementReward({ mainRewardId: [mapKey], specialRewardId: [] }).then(
        (res) => res,
      );
    }

    setIsSwitch(mapDataMain?.length === 0);
    setMainGroup(mapDataMain);
    setMainImgBadge(mapMainBadge);
    setMainImgReward(mapMainReward);
    checkValidate();
  };

  const deleteSpecialGroup = async (key: number) => {
    const mapForm = form2.getFieldsValue(true).specialGroups;
    const mapKey = mapForm.find((d) => d.key === key).mainRewardId;

    const filterForm = mapForm
      .filter((f) => f.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1, rewardNum: i + 1 };
      });
    form2.resetFields(["specialGroups"]);
    form2.setFieldValue(["specialGroups"], filterForm);

    const mapDataMain = specialGroup
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });

    const mapMainBadge = specialImgBadge
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });

    const mapMainReward = specialImgReward
      .filter((x) => x.key !== key)
      .map((y, i) => {
        return { ...y, key: i + 1 };
      });
    if (mapKey) {
      await deleteAchievementReward({ mainRewardId: [], specialRewardId: [mapKey] }).then(
        (res) => res,
      );
    }

    setSpecialGroup(mapDataMain);
    setSpecialImgBadge(mapMainBadge);
    setSpecialImgReward(mapMainReward);
    checkValidate();
  };

  return (
    <>
      <div>
        <Row className='pb-3'>
          <Text level={5} fontWeight={700}>
            ตั้งค่ารางวัล
          </Text>
        </Row>
        <Row style={{ paddingBottom: "20px" }}>
          <ConfigProvider
            theme={{
              token: {
                colorText: "#0068F4",
                fontFamily: "IBM Plex Sans Thai",
              },
            }}
          >
            <Segmented
              size='large'
              value={tab}
              style={{ marginBottom: 8 }}
              onChange={(e) => {
                setTab(e);
              }}
              options={[
                { value: "main", label: "ระดับการสะสม" },
                {
                  value: "special",
                  label: "รางวัลพิเศษ",
                  disabled: !form2.getFieldValue("mainGroups")?.length,
                },
              ]}
            />
          </ConfigProvider>
        </Row>
        <Form form={form2} layout='vertical' scrollToFirstError>
          {tab === "main" && (
            <AchievementCardContainer>
              <Row justify={"space-between"}>
                <Col span={19}>
                  <Text fontWeight={500}>ระดับการสะสม</Text>
                  <br />
                  <Text level={6} color='Text3'>
                    ระดับการสะสมของความสำเร็จ
                  </Text>
                </Col>
                <Col span={3}>
                  <Button
                    title='เพิ่มระดับ'
                    icon={<PlusOutlined style={{ color: color.white }} />}
                    typeButton={
                      !isEdit && mainGroup?.length !== 0 && mainGroup?.length < 3
                        ? "primary"
                        : "disabled"
                    }
                    onClick={() => {
                      !isEdit &&
                        mainGroup?.length !== 0 &&
                        mainGroup?.length < 3 &&
                        (setMainGroup([
                          ...mainGroup,
                          {
                            key: mainGroup?.length + 1,
                          },
                        ]),
                        form2.setFields([
                          {
                            name: ["mainGroups"],
                            value: [
                              ...form2.getFieldValue("mainGroups"),
                              {
                                key: mainGroup?.length + 1,
                                rewardNum: mainGroup?.length + 1,
                              },
                            ],
                          },
                        ]),
                        setMainImgReward([
                          ...mainImgReward,
                          { key: mainImgReward?.length + 1, imgFile: undefined, imgUrl: undefined },
                        ]),
                        setMainImgBadge([
                          ...mainImgBadge,
                          { key: mainImgBadge?.length + 1, imgFile: undefined, imgUrl: undefined },
                        ]));
                    }}
                  />
                </Col>
              </Row>
              <br />
              {mainGroup?.length > 0 ? (
                mainGroup?.map((item, i) => (
                  <>
                    <CollapseContainer
                      key={item.key}
                      collapsible='icon'
                      expandIconPosition='end'
                      expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
                      items={[
                        {
                          ...item,
                          label: addGroupLabel("mainGroups", item.key),
                          children: addGroup("mainGroups", item.key, mainImgBadge, mainImgReward),
                        },
                      ]}
                      defaultActiveKey={mainGroup?.map((x) => {
                        return x.key;
                      })}
                    />
                    <br />
                  </>
                ))
              ) : (
                <AddAchievementContainer
                  onClick={() => {
                    setMainGroup([
                      {
                        key: mainGroup?.length + 1,
                      },
                    ]);
                    form2.setFields([
                      {
                        name: ["mainGroups"],
                        value: [
                          {
                            key: mainGroup?.length + 1,
                            rewardNum: mainGroup?.length + 1,
                            mileStoneName: undefined,
                            badgeMasterId: undefined,
                            targetAmount: undefined,
                            rewardName: undefined,
                            reward: undefined,
                          },
                        ],
                      },
                    ]);
                  }}
                >
                  <img src={image.emptyAchievement} />
                  <Text color='primary' level={4}>
                    + เพิ่มระดับการสะสม
                  </Text>
                  <Text level={6} color='Text3'>
                    โปรดเพิ่มระดับการสะสมสำหรับความสำเร็จ
                  </Text>
                </AddAchievementContainer>
              )}
            </AchievementCardContainer>
          )}
          {tab === "special" && (
            <AchievementCardContainer>
              <Row justify={"space-between"} gutter={16}>
                <Col span={1}>
                  <img src={image.emptyGiftBox} width={50} />
                </Col>
                <Col span={22} style={{ paddingLeft: "30px" }}>
                  <Text fontWeight={500}>รางวัลพิเศษ</Text>
                  <br />
                  <Text level={6} color='Text3'>
                    รางวัลพิเศษที่จะสามารถเข้าร่วมได้ก็ต่อเมื่อถึงระดับที่ตั้งไว้ก่อน
                  </Text>
                </Col>
                <Col span={1}>
                  <Switch
                    disabled={isSwitch}
                    checked={isSpecialReward}
                    onClick={async (e) => {
                      e === false
                        ? Modal.confirm({
                            width: 480,
                            centered: true,
                            icon: null,
                            title: (
                              <Text level={4} fontWeight={600}>
                                ต้องการ{e ? "เปิด" : "ปิด"}ใช้งานรางวัลพิเศษหรือไม่?
                              </Text>
                            ),
                            content: (
                              <Text level={6} color='Text3'>
                                กรุณากด “ยกเลิก” ถ้าท่านไม่ต้องการ{e ? "เปิด" : "ปิด"}ใช้งาน หรือ กด
                                “ยืนยัน” ถ้าท่านต้องการ{e ? "เปิด" : "ปิด"}
                                ใช้รางวัลพิเศษในความสำเร็จนี้
                              </Text>
                            ),
                            okText: "ยืนยัน",
                            cancelText: "ยกเลิก",
                            onOk: async () => {
                              setIsSpecialReward(e);
                            },
                          })
                        : setIsSpecialReward(e);
                    }}
                  />
                </Col>
              </Row>
              <Divider />
              {isSpecialReward && (
                <>
                  <Row justify={"space-between"}>
                    <Form.Item
                      name='receiveSpecialRewardType'
                      label='เงื่อนไขการรับรางวัล'
                      rules={[
                        {
                          required: true,
                          message: "*โปรดเลือกเงื่อนไขการรับรางวัล",
                        },
                      ]}
                    >
                      <Radio.Group
                        defaultValue={"STEP"}
                        disabled={isEdit}
                        style={{ display: "flex", flexDirection: "column", gap: 8 }}
                      >
                        <Radio value={"STEP"}>
                          <Text fontFamily='Sarabun' fontSize={14}>
                            รับรางวัลแบบขั้นบันได (รางวัลสูงสุด)
                          </Text>
                        </Radio>
                        <Radio value={"ALL_LEVELS"} disabled>
                          <Text fontFamily='Sarabun' fontSize={14}>
                            รับรางวัลของทุกๆระดับ (ทุกรางวัลที่สำเร็จ)
                          </Text>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Row>
                  <Row justify={"space-between"}>
                    <Col span={20}>
                      <Text fontWeight={500}>รายการรางวัลพิเศษ</Text>
                    </Col>
                    <Col span={4}>
                      <Button
                        title='เพิ่มรางวัลพิเศษ'
                        icon={<PlusOutlined style={{ color: color.white }} />}
                        typeButton={
                          !isEdit && specialGroup?.length !== 0 && specialGroup?.length < 3
                            ? "primary"
                            : "disabled"
                        }
                        onClick={() => {
                          !isEdit &&
                            specialGroup?.length !== 0 &&
                            specialGroup?.length < 3 &&
                            (form2.setFields([
                              {
                                name: ["specialGroups"],
                                value: [
                                  ...form2.getFieldValue("specialGroups"),
                                  {
                                    key: specialGroup?.length + 1,
                                    rewardNum: specialGroup?.length + 1,
                                  },
                                ],
                              },
                            ]),
                            setSpecialImgBadge([
                              ...specialImgBadge,
                              {
                                key: specialImgBadge?.length + 1,
                                imgFile: undefined,
                                imgUrl: undefined,
                              },
                            ]),
                            setSpecialImgReward([
                              ...specialImgReward,
                              {
                                key: specialImgReward?.length + 1,
                                imgFile: undefined,
                                imgUrl: undefined,
                              },
                            ]),
                            setSpecialGroup([
                              ...specialGroup,
                              {
                                key: specialGroup?.length + 1,
                              },
                            ]));
                        }}
                      />
                    </Col>
                  </Row>
                  <br />
                  {specialGroup?.length > 0 ? (
                    specialGroup?.map((item, i) => (
                      <>
                        <CollapseContainer
                          key={item.key}
                          collapsible='icon'
                          expandIconPosition='end'
                          expandIcon={({ isActive }) => (
                            <DownOutlined rotate={isActive ? 180 : 0} />
                          )}
                          items={[
                            {
                              ...item,
                              label: addGroupLabel("specialGroups", item.key),
                              children: addGroup(
                                "specialGroups",
                                item.key,
                                specialImgBadge,
                                specialImgReward,
                              ),
                            },
                          ]}
                          defaultActiveKey={specialGroup?.map((x) => {
                            return x.key;
                          })}
                        />
                        <br />
                      </>
                    ))
                  ) : (
                    <AddAchievementContainer
                      onClick={() => {
                        setSpecialGroup([
                          {
                            key: specialGroup?.length + 1,
                          },
                        ]);
                        form2.setFields([
                          {
                            name: ["specialGroups"],
                            value: [
                              {
                                key: specialGroup?.length + 1,
                                rewardNum: specialGroup?.length + 1,
                              },
                            ],
                          },
                        ]);
                      }}
                    >
                      <img src={image.emptyGiftBox} height='80px' />
                      <Text color='primary' level={4}>
                        + เพิ่มรางวัลพิเศษ
                      </Text>
                    </AddAchievementContainer>
                  )}
                </>
              )}
            </AchievementCardContainer>
          )}
        </Form>
      </div>
    </>
  );
}

export default AchievementStep2;
